import type { AuthUser } from "@workspace/api-client-react";

/**
 * Client-side plan-tier helpers. These mirror the server guards
 * (`requireStudioPlan` / `requireStudioOperator`) purely to drive the UI —
 * the API is always authoritative and re-checks on every request.
 */

/** The plan tier that unlocks the Adaptive Location feature. */
export const STUDIO_PLAN_KEY = "STUDIO";

/** Account roles allowed to upload/run inside a Studio account. */
const STUDIO_OPERATOR_ROLES = new Set(["ORG_OWNER", "ORG_ADMIN", "SINGLE_USER"]);

/** True when the user's active account is on the Studio plan. */
export function isStudioPlan(user: AuthUser | null | undefined): boolean {
  return user?.planKey === STUDIO_PLAN_KEY;
}

/**
 * True when the user may operate (upload/run) Adaptive Location: a Studio-plan
 * account AND an owner/admin/single-user role. Ordinary members are view-only.
 */
export function canOperateStudio(user: AuthUser | null | undefined): boolean {
  return (
    isStudioPlan(user) &&
    user?.accountRole != null &&
    STUDIO_OPERATOR_ROLES.has(user.accountRole)
  );
}
